import { useState } from 'react';
import '../../styles/user/ForgotPassword.css';
import axios from 'axios';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/auth/forgot-password`, { email }, {
        withCredentials: true
      });
      const data = response.data;
      if (response.ok) {
        setMessage('Instruksjoner for å nullstille passord er sendt til din e-post');
        setError('');
      } else {
        setError(data.message);
        setMessage('');
      }
    } catch (error) {
      setError('Kunne ikke behandle forespørselen');
      setMessage('');
    }
  };

  return (
    <div className="forgot-password-container">
      <form onSubmit={handleSubmit} className="forgot-password-form">
        <h2>Glemt passord</h2>
        {message && <div className="success-message">{message}</div>}
        {error && <div className="error-message">{error}</div>}
        <input
          type="email"
          placeholder="Epost"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <button type="submit">Nullstill passord</button>
      </form>
    </div>
  );
};

export default ForgotPassword; 